export function formatPrice(amount) {
  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 0,
  }).format(amount);
}

export function formatDate(ts) {
  if (!ts) return "—";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString("en-NG", { day: "numeric", month: "short", year: "numeric" });
}

export const CATEGORIES = [
  "Computing",
  "Electronics",
  "Power & Solar",
  "Networking",
  "Home & Office",
  "Fashion",
  "Beauty & Personal Care",
  "Kids & Toys",
  "Party & Gifts",
  "Other"
];

export const CATEGORY_TREE = {
  "Computing": {
    icon: "💻",
    slug: "computing",
    desc: "Laptops, desktops, monitors, printers & computer accessories.",
    badge: "Tech Essentials",
    badgeColor: "#2563EB",
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=600&q=80",
    subcategories: [
      { name: "Laptops", slug: "laptops", icon: "💻", desc: "Ultrabooks, business & gaming laptops" },
      { name: "Desktops", slug: "desktops", icon: "🖥️", desc: "Workstations, tower & all-in-one PCs" },
      { name: "Monitors", slug: "monitors", icon: "🖥️", desc: "Ultra HD, curved & gaming monitors" },
      { name: "Printers & Scanners", slug: "printers-scanners", icon: "🖨️", desc: "Laser printers, copiers & high-res scanners" },
      { name: "Computer Accessories", slug: "computer-accessories", icon: "🖱️", desc: "Keyboards, mice, docks, hubs & pads" },
    ]
  },
  "Electronics": {
    icon: "📺",
    slug: "electronics",
    desc: "LED displays, commercial screens, office gear & adapters.",
    badge: "Smart Displays",
    badgeColor: "#4F46E5",
    img: "https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?auto=format&fit=crop&w=600&q=80",
    subcategories: [
      { name: "LED Screens & Displays", slug: "led-screens-displays", icon: "📺", desc: "Commercial signage, video walls & monitors" },
      { name: "Office Electronics", slug: "office-electronics", icon: "📠", desc: "Projectors, shredders, calculators & electronics" },
      { name: "Cables & Adapters", slug: "cables-adapters", icon: "🔌", desc: "HDMI, DisplayPort, Type-C & power adapters" },
    ]
  },
  "Power & Solar": {
    icon: "☀️",
    slug: "power-solar",
    desc: "Inverters, lithium batteries, solar panels, controllers & lighting.",
    badge: "Clean Energy",
    badgeColor: "#16A34A",
    img: "https://images.unsplash.com/photo-1509391365360-2e959784a276?auto=format&fit=crop&w=600&q=80",
    subcategories: [
      { name: "Inverters", slug: "inverters", icon: "⚡", desc: "Pure sine wave & smart hybrid inverters" },
      { name: "Batteries", slug: "batteries", icon: "🔋", desc: "LiFePO4 lithium & tubular deep-cycle batteries" },
      { name: "Solar Panels", slug: "solar-panels", icon: "☀️", desc: "Monocrystalline, bifacial & flexible panels" },
      { name: "Solar Accessories", slug: "solar-accessories", icon: "🛠️", desc: "MPPT charge controllers, cables & breakers" },
      { name: "Lighting & Electrical", slug: "lighting-electrical", icon: "💡", desc: "LED bulbs, floodlights, switches & wiring" },
    ]
  },
  "Networking": {
    icon: "📡",
    slug: "networking",
    desc: "Starlink satellite dishes, Wi-Fi 6 routers, switches & access points.",
    badge: "High Speed",
    badgeColor: "#0284C7",
    img: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=600&q=80",
    subcategories: [
      { name: "Starlink Kits", slug: "starlink-kits", icon: "🛰️", desc: "Standard, mini & high-performance Starlink setups" },
      { name: "Routers & MiFi", slug: "routers-mifi", icon: "📶", desc: "Wi-Fi 6 mesh routers & portable 4G/5G MiFi" },
      { name: "Network Switches", slug: "network-switches", icon: "🖧", desc: "Gigabit, PoE & managed enterprise switches" },
      { name: "Access Points (EAP110 etc)", slug: "access-points", icon: "📡", desc: "Long-range indoor & outdoor PoE access points" },
    ]
  },
  "Home & Office": {
    icon: "🏠",
    slug: "home-office",
    desc: "Modern home appliances, kitchen electronics & ergonomic furniture.",
    badge: "Everyday Living",
    badgeColor: "#D97706",
    img: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=600&q=80",
    subcategories: [
      { name: "Home Appliances", slug: "home-appliances", icon: "🧺", desc: "Washing machines, fans, vacuum cleaners & irons" },
      { name: "Kitchen Appliances", slug: "kitchen-appliances", icon: "🍳", desc: "Microwaves, blenders, air fryers & refrigerators" },
      { name: "Household Furniture", slug: "household-furniture", icon: "🛋️", desc: "Sofas, dining sets, coffee tables & shelving" },
      { name: "Office Furniture", slug: "office-furniture", icon: "🪑", desc: "Ergonomic mesh chairs, executive desks & cabinets" },
      { name: "Office Supplies", slug: "office-supplies", icon: "📎", desc: "Organizers, paper shredders, files & stationery" },
    ]
  },
  "Fashion": {
    icon: "👔",
    slug: "fashion",
    desc: "Men's and women's fashion, statement shoes & luxury bags.",
    badge: "Trending Style",
    badgeColor: "#EC4899",
    img: "https://images.unsplash.com/photo-1445205170230-053b83016050?auto=format&fit=crop&w=600&q=80",
    subcategories: [
      { name: "Men's Fashion", slug: "mens-fashion", icon: "👔", desc: "Suits, casual wear, native attire & trousers" },
      { name: "Women's Fashion", slug: "womens-fashion", icon: "👗", desc: "Dresses, corporate wear, tops & skirts" },
      { name: "Shoes & Bags", slug: "shoes-bags", icon: "👞", desc: "Leather footwear, sneakers, tote bags & backpacks" },
    ]
  },
  "Beauty & Personal Care": {
    icon: "✨",
    slug: "beauty-personal-care",
    desc: "Personal hygiene, premium skincare & wellness essentials.",
    badge: "Self Care",
    badgeColor: "#8B5CF6",
    img: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?auto=format&fit=crop&w=600&q=80",
    subcategories: [
      { name: "Personal Care", slug: "personal-care", icon: "🧴", desc: "Body washes, lotions, deodorants & hair care" },
      { name: "Health & Beauty", slug: "health-beauty", icon: "💄", desc: "Cosmetics, skincare serums & wellness products" },
    ]
  },
  "Kids & Toys": {
    icon: "🧸",
    slug: "kids-toys",
    desc: "School supplies, creative learning toys & children's apparel.",
    badge: "Kids & Family",
    badgeColor: "#F59E0B",
    img: "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?auto=format&fit=crop&w=600&q=80",
    subcategories: [
      { name: "School Supplies", slug: "school-supplies", icon: "🎒", desc: "Backpacks, lunch kits, stationery & notebooks" },
      { name: "Toys & Games", slug: "toys-games", icon: "🧩", desc: "Puzzles, board games, remote cars & educational kits" },
      { name: "Kids Fashion", slug: "kids-fashion", icon: "👕", desc: "Everyday clothing, shoes & outfits for kids" },
    ]
  },
  "Party & Gifts": {
    icon: "🎁",
    slug: "party-gifts",
    desc: "Celebration accessories, festive decor & curated gift items.",
    badge: "Celebrations",
    badgeColor: "#E11D48",
    img: "https://images.unsplash.com/photo-1513151233558-d860c5398176?auto=format&fit=crop&w=600&q=80",
    subcategories: [
      { name: "Party Supplies", slug: "party-supplies", icon: "🎉", desc: "Balloons, party tableware, banners & party bags" },
      { name: "Gift Items", slug: "gift-items", icon: "🎁", desc: "Corporate gifts, souvenirs, hampers & packaged sets" },
      { name: "Celebration Decor", slug: "celebration-decor", icon: "✨", desc: "Fairy lights, backdrops, confetti & party centerpieces" },
    ]
  }
};

export const SUBCATEGORIES_BY_CATEGORY = Object.entries(CATEGORY_TREE).reduce((acc, [cat, val]) => {
  acc[cat] = val.subcategories.map(s => s.name);
  return acc;
}, { "Other": ["Other"] });

export const CATEGORY_GROUPS = Object.entries(CATEGORY_TREE).map(([group, val]) => ({
  group,
  icon: val.icon,
  slug: val.slug,
  desc: val.desc,
  items: val.subcategories.map(sub => ({
    name: sub.name,
    category: group,
    icon: sub.icon,
    desc: sub.desc,
    slug: sub.slug
  }))
}));

export const CATEGORY_DETAILS = Object.entries(CATEGORY_TREE).map(([name, data]) => ({
  name,
  slug: data.slug,
  icon: data.icon,
  group: name,
  img: data.img,
  badge: data.badge,
  badgeColor: data.badgeColor,
  desc: data.desc,
  subCount: data.subcategories.length,
  subcategories: data.subcategories
}));

export const CATEGORY_SLUG_MAP = {
  // Main Categories
  "computing": "Computing",
  "electronics": "Electronics",
  "power-solar": "Power & Solar",
  "power-and-solar": "Power & Solar",
  "networking": "Networking",
  "home-office": "Home & Office",
  "home-and-office": "Home & Office",
  "fashion": "Fashion",
  "beauty-personal-care": "Beauty & Personal Care",
  "kids-toys": "Kids & Toys",
  "party-gifts": "Party & Gifts",

  // Sub-categories mapped to canonical subcategory names
  "laptops": "Laptops",
  "desktops": "Desktops",
  "monitors": "Monitors",
  "printers-scanners": "Printers & Scanners",
  "computer-accessories": "Computer Accessories",
  "led-screens-displays": "LED Screens & Displays",
  "office-electronics": "Office Electronics",
  "cables-adapters": "Cables & Adapters",
  "inverters": "Inverters",
  "batteries": "Batteries",
  "solar-panels": "Solar Panels",
  "solar-accessories": "Solar Accessories",
  "lighting-electrical": "Lighting & Electrical",
  "starlink-kits": "Starlink Kits",
  "routers-mifi": "Routers & MiFi",
  "network-switches": "Network Switches",
  "access-points": "Access Points (EAP110 etc)",
  "home-appliances": "Home Appliances",
  "kitchen-appliances": "Kitchen Appliances",
  "household-furniture": "Household Furniture",
  "office-furniture": "Office Furniture",
  "office-supplies": "Office Supplies",
  "mens-fashion": "Men's Fashion",
  "womens-fashion": "Women's Fashion",
  "shoes-bags": "Shoes & Bags",
  "personal-care": "Personal Care",
  "health-beauty": "Health & Beauty",
  "school-supplies": "School Supplies",
  "toys-games": "Toys & Games",
  "kids-fashion": "Kids Fashion",
  "party-supplies": "Party Supplies",
  "gift-items": "Gift Items",
  "celebration-decor": "Celebration Decor",

  // Legacy mappings for backwards compatibility
  "laptops-desktops": "Computing",
  "laptops & desktops": "Computing",
  "inverters-batteries": "Power & Solar",
  "solar-equipment": "Power & Solar",
  "solar": "Power & Solar",
  "starlinks-routers": "Networking",
  "cables-accessories": "Electronics",
  "household-appliances": "Home & Office",
  "home-interiors": "Home & Office",
  "machinery": "Electronics"
};

export function resolveCategory(raw) {
  if (!raw) return { category: "", subcategory: "" };
  const lower = raw.toLowerCase().trim();

  // 1. Exact match on main category
  const foundMain = CATEGORIES.find(c => c.toLowerCase() === lower);
  if (foundMain) return { category: foundMain, subcategory: "" };

  // 2. Slug map check
  const mapped = CATEGORY_SLUG_MAP[lower];
  if (mapped) {
    if (CATEGORIES.includes(mapped)) {
      return { category: mapped, subcategory: "" };
    }
    // Check if mapped is a subcategory
    for (const [parent, subs] of Object.entries(SUBCATEGORIES_BY_CATEGORY)) {
      if (subs.some(s => s.toLowerCase() === mapped.toLowerCase())) {
        return { category: parent, subcategory: mapped };
      }
    }
    return { category: mapped, subcategory: "" };
  }

  // 3. Subcategory match check
  for (const [parent, subs] of Object.entries(SUBCATEGORIES_BY_CATEGORY)) {
    const matchedSub = subs.find(s => s.toLowerCase() === lower);
    if (matchedSub) {
      return { category: parent, subcategory: matchedSub };
    }
  }

  return { category: raw, subcategory: "" };
}
